import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextosTerminos = ({ terminos, ruta }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Términos")}
            eyebrow={t("Legal")}
            imagen={terminos.imagen_cabecera ? ruta + "/" + terminos.imagen_cabecera : null}
            html={terminos.ladesc}
        />
    );
}

export default TextosTerminos;
